import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import { Plans } from './types';

const defaultValues: Plans = {
  plans: [],
  loaded: false,
};

const storage = createJSONStorage<Plans>(() => sessionStorage);
export const plans = atomWithStorage<Plans>(
  'plansInfo',
  defaultValues,
  storage
);

export const comparisonIframeSource = atomWithStorage<string | null>(
  'comparisonIframeSource',
  null
);
